import { Component, Input } from '@angular/core';

export interface Sign {
  id: string;
  name: string;
  video: string;
  thumb: string;
  thumbGif: string;
}

@Component({
  selector: 'sign-card',
  template: `
  <h3>{{sign.name}}<h3>

  <img [src]="thumb" [hoverImageSwap]="thumbGif" width="200px" />`,
  styleUrls: ['./sign-card.component.scss']
})
export class SignCardComponent {
  @Input() sign!: Sign;

  get thumb(): string {
    return `/${this.sign.id}/${this.sign.thumb}`;
  }

  get thumbGif(): string {
    return `/${this.sign.id}/${this.sign.thumbGif}`;
  }
}
